$(document).ready(function (){
    $(".chosen-select").chosen({
        no_results_text: "No se encontraron resultados.",
        width: "100%"
    },);


    $(document).on('click', '#btn_solution', function () {
        let textarea = $('#item-solution');
        $("#modal-add-solution").modal('show')
        textarea.val(textarea.val().trim());
        textarea.focus();
        textarea[0].setSelectionRange(0, 0);
    })

    $(document).on('click', '#btn_diagnostic', function () {
        let textarea = $('#item-diagnostic');
        $("#modal-add-diagnostic").modal('show')

        textarea.val(textarea.val().trim());
        textarea.focus();
        textarea[0].setSelectionRange(0, 0);
    })

    $(document).on('click', '#btn_finish', function (e) {
        e.preventDefault()
        Swal.fire({
            title: '¿ Estas seguro ?',
            text: "El ticket sera finalizado y no podrás editarlo.  ",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, finalizar!'
        }).then((result) => {
            if (result.isConfirmed) {
                let data = new FormData()
                let uuid = $(this).data('uuid')
                data.append('uuid',uuid)
                sendData('/finish-ticket',data)
            }
        })
    })

    $(document).on('submit', '#form-add-solution', function (e) {
        e.preventDefault()
        let data = new FormData(this)
        let route = "/add-solution";
        sendData(route,data,'modal-add-solution')
    })

    $(document).on('submit', '#form-add-diagnostic', function (e) {
        e.preventDefault()
        let data = new FormData(this)
        let route = "/add-diagnostic";
        sendData(route,data,'modal-add-diagnostic')
    })

    function sendData(route,data,modal) {
        $.LoadingOverlay("show")
        $.ajax({
            url: route,
            type: 'POST',
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {

                setTimeout(function () {
                    $.LoadingOverlay("hide")
                    if (response.type == "success") {
                        $.LoadingOverlay("hide")
                        $("#"+modal).modal('hide')
                        alertSuccess(response.msg)
                    }

                    if (response.type == "error") {
                        alertError(response.msg)
                    }
                    if (response.type == "view") {
                        $.LoadingOverlay("hide")
                        $("#"+modal).modal('hide')
                        alertSuccess(response.msg)
                        document.getElementById('div_timeline').innerHTML = response.view;
                        document.getElementById('div_options_ti').innerHTML = response.view2;
                    }
                }, 1000)
            }, error: function (errors, xhr, status,) {
                $("#"+modal).modal('hide')
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).html(value)
                });
            }
        });
    }
})

